import { oc } from '@orpc/contract';
import { listPendingApprovalsOutputSchema } from '../schemas/approvals.schemas.js';
/** The administrator's queue: every above-ceiling request still waiting for a decision (plan §5.7). */
export const listPendingApprovalsContract = oc
    .route({
    method: 'GET',
    path: '/approvals/pending',
    tags: ['Approvals'],
    summary: 'List the pending approval requests (administrator)',
})
    .output(listPendingApprovalsOutputSchema);
//# sourceMappingURL=list-pending-approvals.contract.js.map